<template lang="pug">
.app-wrapper
  sidebar.sidebar-container
  .main-container
    navbar
    app-main
</template>

<script>
import { Navbar, Sidebar, AppMain } from './index.js'
export default {
  name: 'BaseLayout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Base/Layout/index.vue